import HttpRequest from'../../../http/index.js';import {MARS_CORE_SERVER_PATH}from'@monorepo/shared';/*
 * @Author: 刘欢
 * @LastEditors: 刘欢
 * @Date: 2024-03-12 20:11:57
 * @LastEditTime: 2024-03-12 20:11:57
 * @Description: 新增或编辑档案设置
 */
/** 保存设置信息 */
const saveSettings = (data) => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/profile_resources/archives_setting.json`,
        data,
        method: 'POST',
    });
};
/** 根据id查询设置集合 */
const getSettings = () => {
    return HttpRequest({
        url: `${MARS_CORE_SERVER_PATH}/profile_resources/archives_setting.json`,
    });
};export{getSettings,saveSettings};//# sourceMappingURL=settings.service.js.map
